import gql from 'graphql-tag';

type MetaImagesResponse = {
  url: string;
};

export const MetaImageProductType = {
  COURSE: 'XDP~COURSE!',
  SPECIALIZATION: 'XDP~SPECIALIZATION!',
  VLP: 'VIDEO_LANDING_PAGE',
} as const;

export type MetaImageProductTypeKeys = typeof MetaImageProductType[keyof typeof MetaImageProductType];

export type MetaImageQueryVariables = {
  productId: string;
  metaImageProductType: MetaImageProductTypeKeys;
};

export type MetaImageQueryData = {
  MetaImagesV1Resource?: {
    elements: MetaImagesResponse[];
  };
};

export default gql`
  query MetaImageQuery($metaImageProductType: String!, $productId: String!) {
    MetaImagesV1Resource(metaImageProductType: $metaImageProductType, productId: $productId)
      @rest(
        type: "MetaImagesV1Resource"
        path: "metaImages.v1/{args.metaImageProductType}~{args.productId}"
        method: "GET"
      ) {
      elements @type(name: "MetaImage") {
        url
      }
    }
  }
`;
